import { useFilterDisabledSettings } from "@api";
import { FormControlLabel, Radio } from "@mui/material";
import { Stack } from "@mui/material";
import { Typography } from "@mui/material";
import { RadioGroup } from "@mui/material";
import { useGlobalContext } from "@root/context";
import { useModalOfferContext } from "../context";
import { classes } from "../styles";

interface ISourceInput {
  isApply: boolean | undefined;
}

export const SourceInput = ({ isApply }: ISourceInput) => {
  const { settings } = useGlobalContext();
  const { offer, setOffer, disabled, errors, setErrors } = useModalOfferContext();

  const settingsOfferOrigin = useFilterDisabledSettings(settings?.settingsOfferOrigin, offer.externalSource);

  return (
    <Stack gap={1} direction="row" alignItems="center" flexWrap="wrap" className={classes.fullWidth}>
      <Typography variant="body1" color={errors.externalSource ? "error.main" : "text.primary"}>
        Qui a trouvé l&apos;offre : *
      </Typography>
      <RadioGroup
        row
        value={offer.externalSource ?? ""}
        onChange={(event) => {
          setOffer((offer) => ({ ...offer, externalSource: event.target.value }));
          setErrors((errors) => ({ ...errors, externalSource: false }));
        }}
      >
        {settingsOfferOrigin.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio size="small" />}
            label={option.label}
          />
        ))}
      </RadioGroup>
    </Stack>
  );
};
